import { Button, Table, TableColumnsType } from 'antd';
import { forwardRef, useContext, useMemo } from 'react';
import useProfitPoolbyHierarchyDataInfiniteScroll from './hooks/useProfitPoolbyHierarchyDataInfiniteScroll';
import { calculateContainerHeight } from 'utils/helperMethods';
import { FilterContextData } from 'contexts/FilterContext';

const ProfitPoolbyHierarchyTable = forwardRef<HTMLDivElement, {}>((props, ref) => {
    const tableHeight = calculateContainerHeight(3);

    const {
        tableData: profitPoolTableDataFinal,
        tableDefinition: profitPoolTableDefinition,
        min,
        max,
        isPending,
        isError,
        isSuccess,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
    } = useProfitPoolbyHierarchyDataInfiniteScroll();

    const { allDimAndAttributeTypeList } = useContext(FilterContextData);

    return (
        <div ref={ref}>
            <Table
                columns={profitPoolTableDefinition}
                dataSource={profitPoolTableDataFinal}
                pagination={false}
                sticky={true}
                scroll={{ y: tableHeight }}
                loading={isPending || isFetchingNextPage || allDimAndAttributeTypeList?.loading}
            />
            <div style={{ textAlign: 'center' }}>
                <Button
                    type="primary"
                    color="purple"
                    className="m-2"
                    onClick={() => fetchNextPage()}
                    disabled={isPending || isFetchingNextPage || !hasNextPage}
                >
                    {isPending || isFetchingNextPage ? 'Loading...' : 'Load More'}
                </Button>
            </div>
        </div>
    );
});
export default ProfitPoolbyHierarchyTable;
